import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installGlobalErrorLogging } from "./lib/systemLogger";

installGlobalErrorLogging();

createRoot(document.getElementById("root")!).render(<React.StrictMode><App /></React.StrictMode>);
